import React from 'react';
import styles from '../AdminShared.module.scss';

interface AutoRefreshControlProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
}

/**
 * Shared admin control for opt-in automatic refresh on operational views.
 */
const AutoRefreshControl = ({ checked, onChange }: AutoRefreshControlProps) => (
    <label className={styles.inlineCheckbox}>
        <input
            type="checkbox"
            checked={checked}
            onChange={(event) => onChange(event.target.checked)}
        />
        Auto refresh every 60s
    </label>
);

export default AutoRefreshControl;
